import React from 'react';
import { Button, ButtonColor, ButtonSize, useShowContextRequired } from 'ui-builder';
import { Project } from 'nekst-api';
import { InformationMessage } from 'features/nekst-widgets';

import styles from './ResumeLaunchingMessage.module.scss';

export function ResumeLaunchingMessage(
  props: {
    openProjectLaunchingFunc: (projectId: number) => void,
  }
) {
  const { data: project } = useShowContextRequired<Project>();

  if (!project.isLaunched && project.name !== 'Nekst Onboarding') {
    return (
      <InformationMessage className={styles.box}>
        You did not fully complete the setup process for this transaction and no new tasks were
        applied
        {' '}
        <Button
          text="Resume Setup"
          size={ButtonSize.MEDIUM}
          onClick={() => props.openProjectLaunchingFunc(project.id)}
          color={ButtonColor.BLUE}
          isFilled
        />
      </InformationMessage>
    );
  } else {
    return null;
  }
}
